import { cartLabelBrands } from '@/helpers/utils/brandname';
export const mapLocaleToMeaningfulFormat = (params?: string[]) => {
  switch ('en') {
    case 'en':
      return {
        name: 'English',
        firstName: '*First Name',
        editFirstName: 'EditfirstName',
        firstNameId: 'firstName',
        shippingMethods: 'Shipping Method',
        lastName: '*Last Name',
        editLastName: 'EditlastName',
        accountAlreadyExist: 'The account already exist.',
        newCardAddedFailed: 'Error occurred while adding Credit card.',
        giftMessageLabel: 'Gift Message',
        mailOrderErrorDiscription:
          'This item is only for invalid/unreadable/discontinued/Not Found information on the order.',
        lastNameId: 'lastName',
        email: '*Email Address',
        paymentFailed: 'Sorry ',
        accountNo: 'Account No',
        partialPremisesDescription:
          'It looks like your apartment/suite/unit number may be missing or incorrect. Please consider editing your address before continuing.',
        streetPartialDescription:
          'It looks like your house/building number may be missing or incorrect. Please consider editing your address before continuing.',
        verifyAddressDescription:
          'It looks like your address may be incorrect or incomplete. Please review our suggestions in ',
        password: '*Password',
        hide: 'Hide',
        emptyAddress1: 'Enter an address',
        updateCardNotificationFailed: 'Error occurred while updating Card details.',
        show: 'Show',
        myAccount: 'My Account',
        orders: 'Orders',
        address: 'Addresses',
        noChargeTitle: 'No Charge',
        createAccount: 'Create an Account',
        createAccountTitle: 'Create Your Stoneberry Account',
        createAccountDescription:
          "If you do not currently have an account, please create one below. You'll be able to save time checking out, view your orders, create a wish list, and more!",
        createAccountAlert: 'Already have a Stoneberry account?',
        signIn: 'Sign In ',
        required: '*Required fields',
        emailUpdates: 'Yes, please send me email updates about new products and exclusive promotions!',
        emailAlert: 'Please enter your email address. We will then send you a link to reset your password.',
        submit: 'Submit',
        forgotPassword: 'Forgot Password?',
        signInMessage: 'Keep me signed in',
        stoneberryCredit: 'My Stoneberry Credit',
        viewOrders: 'View Orders',
        primaryAddress: 'Primary Address: ',
        viewAddress: 'View Addresses',
        myProfile: 'My Profile',
        changePassword: 'Change Password',
        viewProfile: 'View My Profile',
        savedCard: 'Saved Credit Cards',
        primaryCard: 'Primary Card: ',
        viewSavedCards: 'View Saved Credit Cards',
        wishlist: 'Wish List',
        emptyWishlistMsg: 'There are currently no items saved to your wish list.',
        viewWishlist: 'View Wish List',
        insertImage: 'Insert Image',
        totalBalance: 'Total Balance:',
        minDue: 'Minimum Due:',
        paymentDue: 'Payment Due:',
        makePayment: 'Make a Payment',
        creditLimit: 'Credit Limit:',
        availableCredit: 'Available Credit:',
        expiryDate: 'Expiration Date:',
        viewStoneberryCredit: 'View My Stoneberry Credit',
        preQualified: 'Get Pre-Qualified',
        learnMore: 'Learn More',
        emptyOrdersMsg:
          'There are no recent orders in your account, but let’s see if we can find the order you’re looking for.',
        orderLookup: 'Single Order Lookup',
        enterOrderNumberMsg: 'Enter your order number and billing zip code below to view your order’s current status.',
        viewOrderDetails: 'View Order Details',
        makeDownPayment: 'Make a Down Payment',
        signOut: 'Sign Out',
        defaultAddress: 'Default Billing & Shipping Address',
        defaultCard: 'Default Credit Card',
        signInTitle: 'Sign In to Your Stoneberry Account',
        signInDescription: 'If you already have an account, please sign in below.',
        signInAlert: "Don't have a Stoneberry account?",
        signInDrawer: 'Open Sign In Drawer',
        addNewAddressHeading: 'Add New Address',
        emptyAddressMsg: 'There are currently no addresses saved to your account.',
        setDefaultAddress: 'Set as default billing & shipping address',
        saveAddress: 'Save Address',
        editAddress: 'Edit Address',
        optionalText: 'optional',
        cancel: 'Cancel',
        edit: 'Edit',
        remove: 'Remove',
        setDefault: 'Set as Default',
        addressLine2: 'Address Line 2',
        editAddressLine2: 'EditadditionalAddressInfo',
        additionalAddressInfo: 'additionalAddressInfo',
        defaultNotification: 'Primary address updated successfully',
        removeNotification: 'Address deleted successfully',
        recoverAddress: 'Your address have been successfully recovered.',
        updateNotification: 'Address updated successfully',
        addAddressNotification: 'Address added successfully',
        failaddAddressNotification: 'Failed to save address',
        successprofile: 'You have successfully updated your profile',
        passwordNotMatch: 'The password entered does not match the current account password.',
        updatedEmail: 'You have successfully updated your email address',
        contactInfo: 'Contact Information',
        saveChange: 'Save Changes',
        changeEmail: 'Change Email Address',
        verifyEmail:
          'Please verify the information below, and enter your current password to change the email address on your Stoneberry account.',
        oldEmail: 'Old Email Address',
        newEmail: 'New Email Address',
        emailcheckout: 'Please use this new email address next time you sign in or check out.',
        successPassword: 'Password changed successfully.',
        resetPassword: 'Reset Password',
        needHelp: 'Need Help?',
        welcome: 'Welcome!',
        noAddressMsg: 'There are currently no addresses saved to your account.',
        noSavedCardMsg: 'There are currently no credit cards saved to your account.',
        noOrdersMsg: 'There are no recent orders in your account.',
        noWishlistMsg: 'There are currently no items saved to your wish list.',
        expire: 'Expires',
        savedCreditCard: 'Saved Credit Cards',
        addCreditCard: 'Add New Credit/Debit Card',
        defaultCreditCard: 'Default CREDIT CARD',
        emptyCardtitle: 'There are currently no cards saved to your account.',
        securityDescription:
          'For your security, please re-enter your card number and security code, along with any edits.',
        editCard: 'Edit Credit Card',
        setdefaultCreditCard: 'Set as default credit card',
        saveThisCard: 'Save this card',
        billingAddress: 'Billing Address',
        newAddress: 'New Address',
        savedAddress: 'Saved Address',
        saveCardButton: 'Save Card',
        shopOtherSite: 'SHOP OUR OTHER SITES',
        subjectFinalCredit: '*Subject to final credit approval.',
        yourAvailableCredit:
          ' **Your available credit is determined by subtracting your current balance and any unshipped orders from your credit limit.',
        doNotSell: 'Do Not Sell My Personal Information',
        viewAll: 'View All',
        loading: 'Loading...',
        missingLink: 'Missing Link',
        newCardAdded: 'Credit card added successfully',
        defaultCardNotification: 'Primary card updated successfully',
        removeCardNotification: 'Credit card deleted successfully',
        recoverCard: 'Your card have been successfully recovered.',
        updateCardNotification: 'Card details have been updated successfully',
        forgotPasswordMsg:
          'If you have an account with us, you will receive an email with a link to reset your password.',
        order: 'Order #',
        downPaymentRequired: 'Down Payment Required',
        moreItems: 'more items',
        myCart: 'My Cart',
        otherItemsCart: 'Other Items in Cart',
        viewCart: 'View Cart',
        checkOut: 'Check Out',
        subTotal: 'Subtotal',
        cart: 'Cart',
        availability: 'Availability',
        arrivesBy: 'Estimated Arrival:',
        fulfillmentMethod: 'Fulfillment Method:',
        fulfillmentExternal: 'Vendor',
        orderTotal: 'Order Total',
        orderSummary: 'Order Summary',
        estimatedShipping: 'Estimated Shipping',
        shippingSurcharge: 'Shipping Surcharge',
        estimatedSalesTax: 'Estimated Sales Tax',
        viewFAQs: 'View FAQs',
        chatWithUs: 'Chat With Us',
        emailUs: 'Email Us',
        callUsTollFree: 'Call Us Toll-Free',
        inStock: 'In Stock',
        personalization: 'Personalization',
        shoppingCart: 'Shopping Cart',
        delete: 'delete',
        saveForLater: 'Save for Later',
        deliveringTo: 'Delivering to',
        someOrdersTakeLonger: 'Some orders may take longer to arrive due to high demand on our delivery partners.',
        orderNotFoundMessage:
          "We're sorry, but we couldn't find that order. Please verify your order number and billing zip code below, or ",
        contactUs: 'Contact Us',
        forAssistance: 'for assistance.',
        editItem: 'Edit Item',
        updateCart: 'Update Cart',
        personalize: 'Personalize',
        outOfStock: 'Out of Stock',
        removeFromWishlistSuccess: 'You have successfully removed {productName} from your Wish List',
        item: 'Item',
        promotionNotAllowText: 'This brand does not allow promotions on this item.',
        orderStatusContent: 'Sign in below to view your complete order history.',
        viewOrder: 'View Order',
        orderStatus: 'Order Status',
        requiredFields: '*Required Fields',
        orderNumber: '*Order Number',
        billingZipCode: '*Billing Zip Code',
        creditAccountHolder: 'Credit Account Holder:',
        changeHolderNameMessage:
          'If you need to change the credit account holder’s name, please call us at 1-800-704-5480.',
        creditAddress: 'Credit Statement Address',
        overviewTitle: 'Overview',
        startShopping: 'Start Shopping',
        paymentTitle: 'Payment',
        protectedGuardian: 'You Are Now Protected By',
        stoneberryGuardian: 'Stoneberry Payment Guardian™',
        descriptionGuardian:
          "Doesn't it feel great knowing someone's got your back every time you shop? From happy moments like marriages to unexpected surprises like natural disasters, we'll be in your corner, helping to protect your Stoneberry® Credit account.",
        creditProtectDuring: 'Your Stoneberry® Credit is protected during',
        lifeEvents: 'these qualifying life events:',
        termCondition: 'View Stoneberry Payment Guardian™ Terms & Conditions',
        termDescription:
          'All for just $1.99 per month per $100 of your current Stoneberry® Credit account balance. To keep things simple, we calculate the fee amount for you on the last day of your monthly billing cycle and automatically add it to your monthly minimum payment. Zero balance? No charge! Plus, you can cancel anytime.',
        needReview: 'Need to initiate a benefit, cancel or review your protection amounts?',
        successMessage:
          'Thank you for activating. Your enrollment starts today. You will receive a copy of the Stoneberry Payment Guardian™ terms via mail in 7-10 business days. Please read over the eligibility requirements, conditions, and exclusions that may affect your ability to receive benefits. This program is optional and may be canceled at any time. If you cancel within 30 days following your effective date, any fees paid will be refunded.',
        customerCare: 'Customer Care',
        benefitDirect: 'Benefits Direct',
        accountInformation: 'Account Information',
        customerAccount: 'Customer Account #:',
        accountStatus: 'Account Status:',
        lastStatement: 'Last Statement Date:',
        amountPastDue: 'Amount Past Due:',
        nextStatement: 'Next Statement Date:',
        tooltipAccountStatus: 'Account Status',
        current: 'Your account is current. Thank you for keeping your account in good standing.',
        pastDue:
          'Your account is currently past due. Please contact us at 1-608-324-9113 or make your payment online. If you have already made your payment, thank you.',
        suspended: 'Your account has been suspended. Please contact us at 1-608-324-9113 to make your payment.',
        closed:
          'Per your request, we have closed your account. Please contact us at 1-608-324-9113 if you have any questions or would like to reopen your account.',
        inActive:
          'Your account has been closed either because you haven’t made a purchase or payment in a few months or because your new customer offer has expired. Please place an order to reopen your account.',
        noDebtGuardianTitle: 'Life Is Unpredictable, Make Sure You’re Protected',
        noDebtGuardianDescription:
          'No one can predict what life is going to throw their way, but with a little bit of planning, you can be ready for anything. Stoneberry Payment Guardian™ ensures that your Stoneberry Credit account is protected in the case of an unexpected life event, providing you with peace of mind.',
        noDebtGuardianAdditionalInfo:
          'With Stoneberry Payment Guardian™, your Stoneberry Credit balance and monthly payments could be covered for only $1.99 per month per $100 of your current account balance if any of these qualifying events were to occur.',
        noDebtGuardianPriceInfo: 'Peace of mind has never been so affordable',
        noDebtGuardianTermsLink: 'View Stoneberry Payment Guardian™ Terms & Conditions',
        noDebtGuardianCheckboxLabel:
          'I have read and agree to the terms and conditions. I understand there are eligibility requirements, conditions, and exclusions.',
        noDebtGuardianActivateButton: 'Activate Now',
        noDebtGuardianNotSelectedCheckBox: 'Please agree to the terms and conditions to continue.',
        noDebtGuardianAuthorizationMessage:
          'By clicking “Activate Now” I authorize the Stoneberry Payment Guardian™ program cost to be billed to my Stoneberry Credit account. Stoneberry Payment Guardian™ is optional and can be canceled at any time.',
        recentTransactionTitle: 'Recent Account Transactions',
        recentTransactionNote:
          ' Please allow up to 48 hours for payments to be applied to your Stoneberry Credit account.',
        note: 'Note:',
        date: 'Date',
        status: 'Status',
        description: 'Description',
        purchaseCharge: 'Purchase/Charge',
        paymentCredit: 'Payment/Credit',
        currentTooltipTitle: 'Current:',
        pastDueTooltipTitle: 'Past Due:',
        suspendedTooltipTitle: 'Suspended',
        closedTooltipTitle: 'Closed:',
        inActiveTooltipTitle: 'Inactive:',
        reviewDownPayment: 'Review Down Payment',
        downPaymentAmount: 'Down Payment Amount',
        paymentMethod: 'Payment Method',
        editDownPayment: 'Edit Down Payment',
        submitDownPayment: 'Submit Down Payment',
        noCreditCard: 'No credit cards available',
        newCreditCard: 'New Credit/Debit Card',
        savedCreditCardOption: 'Saved Credit/Debit Card',
        editCredit: 'Edit Card',
        emailHeading: 'Email Address:',
        addProtectionPlan: 'Add Protection Plan',
        protectYourPurchase: 'Protect Your Purchase',
        protectionPlan: 'Protection Plan',
        customerCareContact: '1-800-693-9156 (8am-8pm ET, Mon-Fri)',
        directBenefitContact: '1-800-252-3078 (9am-6pm ET, Mon-Fri)',
        titleAddressTooltip: 'APO/FPO Military Address',
        instructionAddressTooltip: 'To ship to a United States Military Address:',
        step1AddressTooltip: 'Enter the APO or FPO code into the City field.',
        step2AddressTooltip: 'In the State field, select:',
        aaAddressTooltip:
          'AA (Armed Forces of the Americas). The Americas, excluding Canada (Zip codes beginning with 340)',
        aeAddressTooltip:
          'AE (Armed Forces Europe) Europe, Middle East, Africa, Canada (Zip codes beginning with 090 through 998)',
        apAddressTooltip: 'AP (Armed Forces Pacific) Pacific (Zip codes beginning with 962 through 966)',
        step3AddressTooltip: 'In the Zip Code field, enter the appropriate zip code:',
        examplesAddressTooltip: 'Examples:',
        fpoAAAddressTooltip: 'FPO AA 34091',
        apoAAAddressTooltip: 'APO AA 34030',
        fpoAEAddressTooltip: 'FPO AE 09508',
        apoAEAddressTooltip: 'APO AE 09815',
        fpoAPAddressTooltip: 'FPO AP 96522',
        apoAPAddressTooltip: 'APO AP 96207',
        ZBSite: 'StoneBerry',
        ZYSite: 'Masseys',
        SMSite: 'ShoeMall',
        ZDSite: 'Mason Easy-Pay',
        MQSite: 'Maryland Square',
        invalidAccount:
          'User authentication failed, please verify the information you entered and reenter or try again later.',
        home: 'Home',
        creditAccountverification: 'Credit Account Verification',
        myAccountMenu: 'My Account Menu',
        creditAccountMessage: 'Please enter the information below to verify your credit account.',
        customerAccountNumber: '*Customer Account Number',
        ssnMessage:
          'In addition, please enter the last four digits of your social security number or your date of birth.',
        lastSsn: 'Last four digits of social security number',
        lastFourSsn: '*Last 4 of SSN',
        dob: 'Date of birth',
        dobItem: '*Date of Birth (MM/DD/YYYY)',
        continue: 'Continue',
        placeholder: 'XXX - XX -',
        keepMeSignIn: {
          heading: 'Keep Me Signed In',
          tooltipContent:
            'By checking this box, you won’t have to sign in as often on this device. For your security, we recommend only using this option on your personal devices.',
        },
        hi: 'Hi',
        comma: ', ',
        exclamation: '!',
        dpqFailureTitle: 'Stoneberry Credit Pre-Qualification Results',
        dpqFailurepreQualificationResults: 'Stoneberry Credit Pre-Qualification Results',
        dpqFailureHi: 'Hi',
        dpqFailureThankYouMessage:
          'Thank you for your interest in Stoneberry Credit! Unfortunately, we are unable to approve a pre-qualified limit for you at this time.',
        dpqFailureShoppingMessage:
          'You can keep shopping and apply for credit during checkout by simply placing an order. A down payment may be required to approve your credit request and complete your order.',
        dpqFailureStartShopping: 'Start Shopping',
        dpqFailureMoreDetails: 'More Details',
        dpqFailureUnableToObtainInfo:
          'We were unable to obtain sufficient information to determine that you meet the criteria for a pre-qualified amount.',
        dpqFailureQuestionsContact:
          'If you have any questions regarding our decision, please call us at 1-608-324-9113.',
        dpqFailureCreditOpportunityAct:
          "The Federal Equal Credit Opportunity Act prohibits creditors from discriminating against credit applicants on the basis of race, color, religion, national origin, sex, marital status, age (provided the applicant has the capacity to enter into a binding contract); because all or part of the applicant's income derives from any public assistance program; or because the applicant has in good faith exercised any right under the Consumer Credit Protection Act. The Federal agency that administers compliance with this law concerning this creditor is the Consumer Financial Protection Bureau, 17 G St NW. Washington DC, 20552.",
        completeForm: 'to complete this form.',
        alreadyStoneberryAccount:
          'Use your account to see your available credit, save time checking out, and more! Already have a Stoneberry account?',
        alreadyStoneberryAccountSignIn:
          'Already have a Stoneberry account? Sign in to make it even easier to complete this form.',
        yourInformation: 'Your Information',
        preQualifiedInstantly: 'Get Pre-Qualified Instantly',
        noImpactCreditScore: 'for Stoneberry Credit with no impact to your credit score!',
        termAndConditionTitle: 'Terms & Conditions',
        formAgreeStatement:
          "I agree that I am providing 'written instructions' to Stoneberry under the Fair Credit Reporting Act authorizing the company to obtain information from my personal credit report. This authorization allows Stoneberry to obtain such information solely to conduct a pre-qualification for credit. Checking the box above constitutes my electronic signature.",
        electronicCommunication: 'Electronic Communications',
        designPattern:
          'I consent to receive disclosures from you electronically through this website. By consenting, I agree that you may provide electronically any and all communications concerning your products and services, my transactions with you, your privacy policy and other agreements between me and you, and any further disclosures required by federal or state law (the “Disclosures”). My consent applies to all products or services that I obtain from you. I understand that Disclosures may be made available to me on your website, and I must have a personal computer with Internet access through a web browser to access the Disclosures and the ability to either print or electronically store the Disclosures. I represent that I have the hardware, software, email address and email capacities described above. I may withdraw my consent to electronic receipt of Disclosures at any time by contacting you. I have the option to receive any Disclosures that you provide electronically in paper form at no cost to me.',
        thankYou: 'Thank You for Your Interest in Stoneberry Credit',
        identifyCreditLimit:
          'We are unable to identify a credit limit for you at this time, but you can still place an order with us today on Stoneberry Credit to apply.',
        topBrands: 'Top Brands',
        logoutMsg: 'You have been successfully logged out.',
        emailErrorMessage: 'Email id already exists',
        currentPassword: '*Current Password',
        passwordReq: 'Your Password must contain at least :',
        eightCharacter: '8 characters',
        oneLetter: '1 letter',
        oneNumber: '1 number',
        state: '*State',
        payments: 'Payments',
        decryptedStars: '****',
        optionDefault: 'default',
        optionComfortable: 'comfortable',
        optionCompact: 'compact',
        colon: ':',
        samePasswordError: 'New password cannot be same as old password.',
        existingEmail: 'There is already an existing customer with the provided email.',
        successfulSignInMessage: 'You have been successfully signed in to your account',
        errorResetPasswordMessage: 'Password Already Reset',
        successResetPasswordMessage: 'Your password has been updated successfully.',
        newPassword: '*New Password',
        amex: 'amex',
        enterCreditCardNumber: 'Enter Credit Card Number',
        invalidCreditCardNumber: 'Invalid Credit Card Number',
        invalidExpDate: 'Enter a valid Exp.date',
        securityCode: 'Enter Security Code',
        ssnNumber: 'SSN number is of 4 digits.',
        customerAccountNumberMessage: 'Enter an account number.',
        validDOB: 'Please enter valid date of birth.',
        unknown: 'unknown',
        months12: 'Last 12 Months',
        months24: 'Last 2 Years',
        months36: 'Last 3 Years',
        backspace: 'Backspace',
        tab: 'Tab',
        arrowLeft: 'ArrowLeft',
        arrowRight: 'ArrowRight',
        enterAccount: 'Enter an account number.',
        phoneTooltipText:
          'We ask for your phone number in case we need to contact you regarding your order. We respect your privacy and will not share your phone number with any third party vendors. For more details on how we use your information, please see our ',
        privacyPolicyPage: 'Privacy Policy page',
        phoneNumber: 'Phone Number',
        signUpOfferTitle: 'Sign Up for 15% Off Your First Order!',
        signUpEmailComment:
          'Sign up for Stoneberry emails to receive exclusive promotions and be the first to know about new items!',
        signUp: 'Sign Up',
        separator: '/',
        invalidTokenMsg:
          'The password reset link you selected has already been used. You may access your account using the password you most recently entered. If you do not remember your password, please use the Forgot Password.',
        c2: '-C2',
        step2: 'Step 2',
        step1: 'Step 1',
        telephoneNumber: 'Telephone Number',
        selectSize: 'Select Size',
        selectColor: 'Select Color',
        size: 'Size',
        color: 'Color',
        whatThis: `What's This?`,
        customerNumber: 'Customer Account Number',
        accountContent:
          'Your Customer Account Number can be found in the upper right corner of your monthly billing statement',
        enterPassword: 'Enter a password.',
        ssnError: 'Please select either SSN or date of birth.',
        passwordRequired: 'Please enter a valid password.',
        orderRequired: 'Order Number is required',
        addressLine1: '*Address Line 1',
        editAddressId: 'Editaddress',
        addressId: 'address',
        city: '*City',
        editCity: 'Editcity',
        cityId: 'city',
        zipCode: '*Zip Code',
        editZipCode: 'EditzipCode',
        zipCodeId: 'zipCode',
        phoneNumberItem: '*Phone Number',
        phoneNumberItemOptional: 'Phone Number (optional)',
        editPhoneNumber: 'EditphoneNumber',
        phoneNumberId: 'phoneNumber',
        inputPassword: 'password',
        inputNewPassword: 'newPassword',
        inputCardNumber: 'cardNumber',
        inputSecurityCode: 'securityCode',
        inputLoginPassword: 'loginPassword',
        emptyCartMessage: 'Your shopping cart is empty.',
        haveAnAccount: 'Have an account? ',
        signInCartMessage: ' to view items that were previously added to your cart.',
        continueShopping: 'Continue Shopping',
        signInLowerCase: 'Sign in',
        editCardType: 'editCard',
        addCardType: 'addCard',
        cardNumber: '*Card Number',
        cardNumberText: 'Card Number',
        editCardNumber: 'EditcardNumber',
        expiryDatePlaceholder: '*Exp. Date (MM/YY)',
        expDate: 'expDate',
        editExpDate: 'editExpDate',
        securityCodePlaceholder: '*Security Code',
        securityCodeId: 'securityCode',
        editSecurityCode: 'editSecurityCode',
        saveCreditDebitCard: 'Saved Credit/Debit Card',
        newCreditDebitCard: 'New Credit/Debit Card',
        paymentConfirmation: 'Payment Confirmation',
        accountNumber: 'Account Number',
        paymentAmount: 'Payment Amount',
        reviewPayment: 'Review Payment',
        submitPayment: 'Submit Payment',
        editPayment: 'Edit Payment',
        minimumDue: 'Minimum Due',
        paymentSuccess: 'Thank you for your payment',
        paymentSuccessMessage:
          'Please allow up to 48 hours for your payment to be applied to your Stoneberry Credit account.',
        paymentInformation: 'Payment Information',
        emailRequired: 'Please enter a valid email address',
        visa: 'visa',
        mastercard: 'mastercard',
        discover: 'discover',
        result: 'Result for ',
        spelling: 'Please check spelling, try a more general search, or use fewer keywords.',
        sorry: 'Sorry, there are no results for',
        shopAll: 'Shop All',
        inputcreditAccountId: 'creditAccountId',
        inputSsn: 'ssn',
        inputDob: 'dob',
        filter: 'Filters',
        clearAll: 'Clear All',
        items: 'items',
        invalidPostalMsg: 'Invalid Postal Code',
        itemAdded: 'item added to cart',
        itemsAdded: 'items added to cart',
        unknownError: 'Unknown Error! Please try again later!',
        addToCart: 'Add to Cart',
        adding: 'Adding',
        showLess: 'Show less',
        showMore: 'Show more',
        questionMark: '?',
        addressLineError: 'Enter an address',
        addressLineMaxLength: 'Maximum 30 characters are allowed',
        addressMessage: 'Please enter a valid address',
        invalidChar: 'Invalid character',
        tbd: 'TBD',
        promoCode: 'Promo code',
        applyToOrder: 'applied to order',
        applyCode: 'Apply Code',
        hasAppliedToOrder: 'has been applied to your order.',
        isNotValid: 'is not valid',
        hasRemovedFromOrder: 'has been removed from your order.',
        removed: 'Removed',
        errorInRemoving: 'Error in removing',
        itemFromCart: 'item from the cart',
        updateError: 'Error in updating lineItem',
        addToWishList: 'Add to Wish List',
        itemAddedToWishList: ' Added to Your Wish List.',
        unKnownError: 'UnKnown Error! Please try again after sometime.',
        addedToWishList: 'Added to Wish List',
        removing: 'Removing',
        saveForLaterSuccessMessage: 'was successfully saved for later.',
        errorInAdding: 'Error in adding',
        toSaveForLater: 'to save for later',
        verifyAddress: 'Verify Your Address',
        suggestedAddress: 'Use Suggested Address',
        recommended: '(Recommended)',
        editYourAddress: 'Edit Your Address',
        originalAddress: 'Use Original Address',
        originalAddressAlert: ' Original address may be undeliverable.',
        verifyEditAddressAlert: 'Verify your house/building number.',
        savedCreditRadioOption: 'savedCredit',
        newCreditRadioOption: 'newCredit',
        accountErrorMessage: 'error while fetching account data',
        addToCartError: 'Error in adding lineItem',
        removeAll: 'Remove all',
        backOrdered: 'Backordered',
        onlyLeft: `Only ${params ? params[0] : '0'} left in Stock`,
        viewMoreDetails: 'View More Details',
        creditStatementAddress: 'Credit Statement Address',
        onlyCanBeOrdered: `Only ${params ? params[0] : '0'} can be ordered at this time`,
        beginSecureCheckout: 'Begin Secure Checkout',
        signInCheckOut: 'Sign In & Check Out',
        guestCheckout: 'Check Out as Guest',
        guestCheckoutDescription:
          "You don't need an account to check out. Just continue as guest, and create an account later if you'd like",
        continueAsGuest: 'Continue as Guest',
        month: 'month*',
        decryptedStar: `****${params ? params[0] : '0'}`,
        emptyFirstNameErrorMessage: 'Enter a First Name',
        emptyLastNameErrorMessage: 'Enter a Last Name',
        emptyEmailErrorMessage: 'Enter an email address',
        emailRequiredForWorryFreeDelivery: 'Email address is required to purchase Worry Free Delivery.',
        currentPaswordErrorMessage: 'Enter your current password.',
        inputCurrentPassword: 'currentPassword',
        subtotalItems: `Subtotal (${params ? params[0] : '0'} Items): `,
        totalItems: `${params ? params[0] : '0'} Items`,
        free: 'FREE',
        pricePerMonth: `${params ? params[0] : '0'}/month*`,
        termAndCondition: 'Terms and Conditions',
        termConditionDesc: 'This data will be available once figma is ready.',
        sizeChart: 'Size Chart',
        shipCode: 'Ship Code',
        akhiTerritoriesAvailText: 'Shipping to Alaska, Hawaii, or U.S. Territories (PR, GU, VI, MP, AS, FM, MH, PW).',
        apoFpoAvailText: 'Shipping to Military APO/FPO addresses (AA, AE, AP).',
        poBoxAvailText: 'Shipping to a PO Box. It must be shipped to a physical address.',
        priorityShipAvailText: 'Expedited shipping service.',
        shippingTo: 'Shipping to',
        forceLTLShipText: `This item does not qualify for shipping to ${params ? params[0] : ''}`,
        or: 'or',
        withBrandCredit: `with ${params ? params[0] : ''} credit`,
        withBrandZD: `with ${params ? params[0] : ''}®`,
        save: 'Save',
        verifyAddressDescription1: 'bold',
        verifyAddressDescription2: ', or consider editing your address before continuing.',
        noMatchDescription: 'Sorry, we could not find a match for your address.',
        noMatchDescription1: 'To proceed, please choose one of the options below.',

        selectVerifiedAddress: 'Select a Verified Address',
        verifiedMatch: 'verified match',
        interactionRequired: 'interaction required',
        suggestedChanges: 'Suggested changes are in',
        bold: 'bold.',
        recommendLabel: 'recommended',
        originalLabel: 'original',
        editLabel: 'edit',

        phoneNumberErrorMessage: 'Please enter a 10 digit phone number.',
        invalidPhoneNumberMessage: 'Phone number cannot be all zeroes',
        expired: 'Expired',
        emptyCreditCardNumber: 'Enter a credit card number.',
        emptyCvv: 'Enter a Security Code.',
        emptyCreditCardCvv: 'Enter a Security Code.',
        emptyCity: 'Enter a city.',
        emptyState: 'Select a state.',
        emptyzipcode: 'Enter a zip code.',
        emptyphone: 'Please enter a 10 digit phone number.',
        invalidPostalCode: 'Please enter a 5 or 9 digit zip code.',
        invalidLoginErrorMessage: 'The supplied user name or password is incorrect',
        somethingWentWrong: 'Something Went Wrong',
        expiredCardUseMessage:
          'The saved credit/debit card you selected is expired. Please edit that card or select a different card to continue.',
        paymentAmountErrorMessage:
          'The minimum payment amount is $5, your minimum payment amount or your current account balance, whichever is less',
        paymentUnsuccessfulMessage:
          'We are sorry to inform you that we are unable to	process your payment at this time. Please try again at a later date or contact a customer service representative.',
        declinedTransactionError:
          'The card number, expiration date or security code you entered is invalid. Please verify this information, and try again.',
        invalidPaymentAmountError: 'Your payment amount cannot exceed your total account balance',
        paymentAmountLessThanMinDueWarning:
          'Paying less than the minimum amount currently due on your account by the due date may incur late fees and additional interest.',
        ok: 'OK',
        approved: 'APPROVED',
        declined: 'DECLINED',
        credit: 'credit',
        payment: params ? 'Payment' : 'payment',
        cardNumberLabel: 'cardNumber',
        downPaymentOtherAmountErrorMessage: 'Amount must be equal to or more than ${0} and less than or equal to ${1}',
        otherAmountZeroErrorMessage: 'Other amount cannot be zero',
        downPaymentSuccessfulMessage: `Congratulations! Your ${
          params ? params[0] : 'Stoneberry'
        } Credit Order has been approved.`,
        useAddress: 'Use Address as Entered',
        noMatch:
          'Sorry, we could not find a match for your address with USPS. Please edit your original address before continuing, or it may be undeliverable.',
        missingAptUnit:
          'It looks like your apartment/suite/unit number may be missing or incorrect. Please provide that info below, use your original address as entered, or edit your original address before continuing.',
        missingHouseNumber:
          'It looks like your house/building number may be missing or incorrect. Please provide that info below, use your original address as entered, or edit your original address before continuing.',
        default: 'It looks like your address may be incorrect or incomplete. Please review our suggestions in ',
        default1: 'bold',
        default2: 'use your original address as entered, or edit your original address before continuing.',
        editProfile: 'Edit Profile',
        suggestAddress: 'Suggested Address',
        suggested: 'suggested',
        original: 'original',
        originalAddressTitle: 'Original Address',
        completeAddress: 'Complete Your Address',
        undeliverableAddress: 'Original address may be undeliverable.',
        exampleAddress: 'Examples: Apt 101, Unit 202',
        creditAddressUpdatedSuccessMessage: 'Address Updated Successfully',
        creditAddressUpdatedFailureMessage: 'There was an error while updating address',
        paymentGuradianSuccessMessage: 'Payment Guradian Successfully addded',
        paymentGuradianfailureMessage: 'There was an error while adding Payment Guradian',
        dpqFormSubmitError: 'There is some error while submitting the form',
        deliveryError:
          'One or more of your items cannot be shipped to a PO Box. Please select a different delivery address or remove this item.',
        searchImageBanner: 'search_image_banner',
        notAvailable: 'N/A',
        closedAccount: 'Closed',
        searchBoxPlaceholder: `${'Search Keyword'}`,
        cartLabel: `${'Cart'}`,
        catalogRequest: 'Request a Catalog',
        catalogDescription: `Enter your information below to receive a FREE ${
          params ? params[0] : 'Stoneberry'
        } catalog, and in the meantime, view our `,
        online_Catalog: 'Online Catalog.',
        signupForEmail: 'Sign Up for Email',
        signupDesc: `Enter your email address below to also sign up for ${
          params ? params[0] : 'Stoneberry'
        } emails. You’ll receive exclusive promotions, and be the first to know about new items!`,
        requestCatalog: 'Request a Catalog',
        optionalEmailAddress: 'Email Address (optional)',
        chooseOptions: 'Choose Options',
        mayBeLater: 'Maybe Later',
        itemsInOrder: 'Items in Order',
        backToCustomerDetails: 'Back to Customer Details',
        totalPrice: 'Total Price',
        quantity: `Qty${params ? params[0] : ''}`,
        placeOrder: 'Place Order',
        shipping: `Shipping${params ? params[0] : ''}`,
        creditDebitCard: 'Credit/Debit Card',
        registerCheckoutMessage: `To use ${
          params ? params[0] : 'Stoneberry'
        } Credit, you must create a new account here or sign in to an existing account.`,
        guestCheckoutPaymentMessage:
          'To continue checkout as a guest, select Credit/Debit Card as your payment method above.',
        stoneberryCreditManage: `${params ? params[0] : 'Stoneberry'} Credit Managed`,
        contentArea: 'Content Area',
        newCustomer: 'New Customer',
        secureCheckout: 'Secure Checkout',
        returnToCart: 'Return to Cart',
        sameAsBillingAddress: 'Same as Billing Address',
        continueToReview: 'Continue to Review',
        shippingAddress: 'Shipping Address',
        review: 'Review',
        reviewMessage: 'Please review the details on this page, and place your order.',
        useBillingAddress: 'Use Billing address',
        continueToPayment: 'Continue to Payment',
        itemsInCart: 'Items in Your Cart',
        maxCartIconCount: '99+',
        thankYouTitle: 'Thank You!',
        thankYouDescFirstHalf:
          'Thank you for requesting a free catalog. You can expect to receive your new Stoneberry catalog shortly. In the meantime, view our ',
        online_Catalogs: 'Online Catalogs,',
        thankYouDescSecHalf: ' or shop our site to see every product in the catalog - and more!',
        ccpaHeading: 'California Resident Information Request Form',
        purposeRequest: '*Purpose of Request',
        ccpaDesc:
          'Two-step verification is required. After successful form submission, please check your email to complete the process.',
        ccpaSuccessHeading: 'California Resident Information Request Submitted',
        ccpaSuccessDesc:
          'Your information request has been submitted. You will receive a follow-up email which will require further action as part of our two-step verification on information requests.',
        ccpaFormSubmitted: 'Form submitted successfully',
        ccpaFormFailed: 'Error while submitting Form',
        selectRequestPurpose: 'Select Request Purpose',
        changedYourMind: 'Changed your mind?',
        orderCancel: 'order',
        orderCancelMsg: 'Are you sure you want to cancel your order?',
        itemCancel: 'item',
        itemCancelMsg: 'Are you sure you want to cancel this item?',
        cancelMsg: 'Are you sure you want to cancel?',
        yesCancel: 'Yes, Cancel',
        goBackToOrder: 'No, Go Back to Order',
        placedOn: 'Placed on ',
        subtotal: 'Subtotal',
        surcharge: 'Shipping Surcharge',
        salesTax: 'Sales Tax',
        ordertotal: 'Order Total',
        returnRefund: 'Post-Order Refund(s)',
        contactinfo: 'Contact Info',
        batchNumberPlaceholder: '*Batch Number',
        cashNumberPlaceholder: '*Cash Amount',
        checkNumberPlaceholder: '*Check Number(s)',
        totalCheckAmountPlaceholder: '*Total Check Amount',
        invalidPayment: 'Invalid payment method',
        catalogItems: 'Catalog ID (optional)',
        catalogId: 'Catalog Id',
        DOB: 'DOB',
        ssn: 'SSN',
        Cash: 'Cash',
        batchNumber: 'Batch Number',
        cashAmount: 'Cash Amount',
        Check: 'Check',
        checkNumber: 'Check Number',
        totalCheckAmount: 'Total Check Amount',
        captchaError: 'There was some error while validating captcha. Please try again in some time.',
        captchaRequired: 'Enter a valid Captcha',
        processingRequestError: 'An error occurred while processing your request',
        accountCreatedSuccessfully: 'Account Created Successfully',
        trackShipmet: 'Track Shipment: ',
        itemId: 'Item #: ',
        productReview: 'Write a Product Review',
        movetoCart: 'Move to Cart',
        processRequest: 'Please wait while we process your request',
        processing: 'Processing...',
        processRequestDesc:
          'Don’t click the back button, refresh or close your browser until it finishes processing. This may take up to 15 seconds.',
        savedForLater: 'Saved for Later',
        fromSaveForLater: 'from save for later.',
        removedFromSaveForLaterSuccessMessage: 'was successfully removed from save for later wishlist.',
        movedToCartSuccessMessage: 'was successfully moved to cart.',
        errorInMoving: 'Error in moving',
        batchId: 'Batch Id',
        paypalId: 'PayPal Transaction Id',
        pageNotFound: 'Page Not Found',
        pageNotFoundDesc: `We’re sorry, but we couldn’t find the page you’re looking for. Please check the address, or continue shopping.`,
        failedAddCCMessage: 'We are unable to save your card at this time. Please try again later.',
        shippingMethodError: 'Error in setting shipping method',
        shippingAddressUpdateError: 'Error in updating shipping address in cart',
        shippingAddressEditError: 'Error in editing shipping address',
        shippingAddressCreateError: 'Error in adding new shipping address',
        selectShipping: 'Please select a shipping method',
        pendingDownPayment: 'Pending Down Payment',
        movingOrder: 'Keep your order moving!',
        downPaymentMsg1: 'We can approve your order right now',
        downPaymentMsg2: 'if you make a down payment of:',
        PageNotFoundDesc: `We’re sorry, but we couldn’t find the page you’re looking for. Please check the address, or continue shopping.`,
        giftMessageLength: '/60 characters',
        giftMessage: 'Gift Message (optional)',
        giftMessageId: 'giftTextarea',
        giftMessagePlaceholder: 'Gift Message',
        pleaseText: 'Please ',
        downPaymentText: 'to make a down payment or cancel this order.',
        genericFailedError: 'There was an error while processing your request.',
        errorfetchingOrder: 'There was an error fetching your order.',
        itemCanceledMessage: 'Your Item has been canceled.',
        orderCanceledMessage: 'Your Order has been canceled.',
        errorProcessingRequest: 'Sorry, We’re unable to process your request at this time.',
        eventRequestCancelEntireOrder: 'RequestCancelEntireOrder',
        eventRequestCancelLines: 'RequestCancelLines',
        createdByWEB: 'WEB',
        messageChangedMind: 'changedMind',
        availabilityText: 'Availability: ',
        arrivesByText: 'Arrives by ',
        totalPriceText: 'Total Price:',
        quickView: 'Quick View',
        view: 'View',
        viewResult: 'View Results',
        addAddress: 'Add Address',
        addCard: 'Add Credit Card',
        learnMoreDrawerQ1: 'Why am I being asked to make a down payment?',
        learnMoreDrawerA1:
          'Down payments are occasionally required for final credit approval. There are a number of factors that determine if a down payment is needed and what amount is required. Whether you make a down payment or not, you will receive a letter in the mail with more information related to your credit request within 7-10 days.',
        learnMoreDrawerQ2: 'Need to wait?',
        learnMoreDrawerA2:
          'If you decide not to make a down payment right now, we will hold your order details but can’t guarantee your item(s) will remain in stock.',
        learnMoreDrawerQ3: 'To make a down payment later, simply:',
        learnMoreDPstep1: `to your ${params ? params[0] : ''} account.`,
        learnMoreDPstep1Go: `Please go to your ${params ? params[0] : ''} account.`,
        learnMoreDPstep2: 'Find this order on your Orders page.',
        learnMoreDPstep3: 'Click the Make a Down Payment button.',
        worryFreeDelivery: 'Worry-Free Delivery®',
        cancelWorryFreeDelivery: 'Cancel Worry-Free Delivery®',
        sendClaimEmail: 'Send Claim Email',
        claimPending: 'CLAIM PENDING',
        claimAccepted: 'CLAIM ACCEPTED ',
        claimRejected: 'CLAIM REJECTED ',
        worryFreeDeliveryDesc: `Get a full refund if the order doesn't arrive as described, including loss & damage in transit`,
        downPaymentRequest: 'mayBeLater',
        sameShippingAddress: 'Same as Shipping Address',
        editBillingAddress: 'Edit Billing Address',
        viewMore: 'View More',
        viewLess: 'View Less',
        orderStatusError1:
          'We’re sorry, but we couldn’t find that order. Please verify your order number and billing zip code below, or ',
        orderStatusError2: ' for assistance.',
        contactUsPagePath: '/contact-us',
        submitPrequalError: 'Error in submitting pre-qualification',
        updateCartError: 'Error in updating cart',
        tokenizeCardError: 'Error in tokenizing card',
        cardDeclinedError: 'Card is not approved to place order',
        results: 'Results for',
        onlineCatalogTitle: `${params ? params[0] : 'Stoneberry'}’s Online Catalog`,
        onlineCatalogDesc:
          'Enjoy browsing through our most current catalog below. To have a printed version mailed to you, please ',
        sortBy: 'Sort By:',
        reviewsCount: `${params ? params[0] : ''} Reviews`,
        popularSearch: 'Popular Searches',
        recentSearch: 'Recent Searches',
        orderDiscount: 'Order Discount',
        orderConfirmation: 'Order Confirmation #',
        orderHash: 'Order #',
        orderSuspendedTitle: 'Your order has been suspended.',
        orderSuspended: 'Order Suspended',
        orderSuspendedMessage: `Your order cannot be approved on ${
          params ? (params[0] === 'Mason Easy-Pay' ? `${params[0]}®` : `${params[0]} Credit`) : 'Stoneberry Credit'
        }. Please consider placing your order again using a different payment method.`,
        downPaymentTitle: 'Pending Down Payment',
        orderMoving: 'Keep your order moving!',
        orderPendingMessage: 'Your order has been submitted and is pending down payment.',
        orderPendingMsg1: 'We can approve your order right now if you make a down payment of:',
        orderPendingApprovalTitle: 'Your order has been submitted and is pending credit approval.',
        orderPendingCreditApproval: 'Pending Credit Approval',
        orderPendingCreditMessage:
          'For your security, your Stoneberry® Credit application is pending approval. Your order has been placed successfully, but we will need a few additional days to review and verify the information you provided. If you have any questions, please call us at 1-800-704-5480.',
        confirmationEmailMsg1: 'A confirmation email was sent to ',
        confirmationEmailMsg2: 'with your order information.',
        emailMsg1: ' If the email doesn’t arrive within five minutes, please check your spam folder.',
        emailMsg2: ' , and one of our Customer Service Representatives will be happy to help you.',
        standardShipping: 'Standard Shipping',
        preQualificationResults: 'Pre-Qualification Results',
        creditReportAuthorization: 'Credit Report & Electronic Communications Authorization',
        privacyPolicy: 'Privacy Policy',
        applyPromoCode: 'Apply Promo Code',
        returningCustomer: 'Returning Customer',
        creditLogo: '/images/mason/{0}-creditLogo',
        creditPaymentLogo: '/images/mason/{0}-creditPaymentLogo.png',
        creditOrderLogo: '/images/mason/{0}-creditOrderLogo.png',
        paymentGaurdianLogo: '/images/mason/{0}-paymentguardian.png',
        deliveryLocation: 'Delivery Location',
        deliveryLocationInfoMsg: 'or sign in to use your default address',
        apply: 'Apply',
        arrivalDateFormat: 'ddd, MMM DD YYYY',
        arrivalDateFormatWithYear: 'ddd, MMM DD, YYYY',
        arrivalDate: 'arrivalDate',
        pdpPage: 'PDP',
        cartPage: 'CART',
        yes: 'YES',
        standardShipMethod: 'Standard',
        dropShipEligible: 'dropShipEligible',
        contactInformation: 'Contact Information',
        passwordText: 'Password',
        estimatedSalesTaxDesc: `${
          params ? params[0] : 'Stoneberry'
        } is required to collect sales tax on orders for residents of certain states. Sales tax shown here is an estimate. Actual sales tax is calculated when your order is placed and will be shown in your order confirmation email.`,
        passwordRequirements: 'Password Requirements',
        passwordTooltipDesc: 'To achieve a strong password, your password must contain at least:',
        accountIsLocked: 'Account Is Locked',
        oneMoreThing: 'One More Thing!',
        debtProtectionMessage:
          'This and all orders placed with your Stoneberry® Credit account could be protected from financial hardships with credit account protection from Stoneberry Payment Guardian™. Find out how to get started now!',
        width: 'Width',
        selectWidth: 'Select Width',
        ccpaFormStateValidation: 'This form is only valid for California state.',
        california: 'CA',
        saveThisAddress: 'Save this Address',
        error: 'Error',
        sort: 'Sort',
        expirationDate: 'Expiration Date',
        maxOrderQuantityError: `We're sorry, but Item #${
          params ? params[0] : ''
        } can't be added to your Shopping Cart because it has reached its maximum number of items. Please complete your order for the items below and place a new order for additional items, or call us at ${
          params ? params[1] : ''
        } to place one larger order.`,
        learnMoreTitle: `Learn More`,
        updating: 'Updating',
        onlyMorePricePerMonth: `Only ${params ? params[0] : ''} more per month*`,
        p65Warning: 'WARNING',
        p65Text: ' Cancer and Reproductive Harm -',
        p65LinkText: ' www.P65Warnings.ca.gov',
        p65Link: 'https://www.p65warnings.ca.gov/',
        excludedBrand: 'Excluded Brands',
        brandDesc: 'The following brands are excluded from promotions.',
        outOfStockClass: 'text-[#DF2429]',
        you: 'you',
        shippingSameAsBilling: 'Shipping Address is same as Billing',
        expressShippingMethod: 'express',
        standardShippingMethod: 'standard',
        priorityShippingMethod: 'priority',
        cartItemShippingMethodNotApplicableError: `This item does not qualify for expedited shipping and will be sent via standard shipping.`,
        shippingMethodNotApplicableError: `One or more of your items does not qualify for expedited shipping and will be sent via standard shipping.`,
        cartItemOutOfStockError: `One or more items in your ${
          params ? (cartLabelBrands?.includes(params[0]) ? 'cart' : 'bag') : 'cart'
        } is out of stock.`,
        stateNotAvailPageLevelText: `One or more of your items cannot be shipped to ${
          params ? params[0] : ''
        }. Please select another address.`,
        stateNotAvailItemLevelText: `This item cannot be shipped to  ${
          params ? params[0] : ''
        }. Please select another address`,
        requiredSize: 'Please select a size',
        requiredWidth: 'Please select a width',
        pdpPricePerMonth: `Price Per Month`,
        PPMcontent: `The price per month reflects merchandise price only. Actual monthly payment may vary based on your total order
        amount, including shipping and processing, and your current account balance.`,
        ppmTnc: `terms and conditions`,
        soaAccountCurrentStatus: 'current',
        personalizeError: `We're sorry; personalization is temporarily unavailable. Please try again later or call 1-866-855-0203 to place your order via phone.`,
        successfullyRemovedFromCart: `was successfully removed from your ${
          params ? (cartLabelBrands?.includes(params[0]) ? 'cart' : 'bag') : 'cart'
        }.`,
        arrivalDateFormatWithoutYear: 'ddd, MMM DD',
        inStockMsg: `${
          params && parseInt(params[0]) > 3 ? `${params[0]} In Stock` : `Only ${params?.[0]} Left in Stock`
        }`,
        colorProductOutofStock: `The color <b>${
          params ? params[0] : ''
        }</b> is currently out of stock. Please select a different color to continue.`,
        shoppingBag: 'Bag',
        promoBrandExclusion: ' cannot be applied to your order due to brand exclusions.',
        promoInvalid: ' is invalid or has expired. Please verify and reenter.',
        hasAppliedToOrderWithExcludedItems:
          'has been applied to your order, but some item(s) in your bag are excluded.',
        emptyPromoCode: 'Please enter a valid promo code.',
        streetNameLabel: 'streetName',
        streetNameLabelModal: 'streetName_modal',
        additionalAddressInfoLabel: 'additionalAddressInfo',
        additionalAddressInfoLabelModal: 'additionalAddressInfo_modal',
        inputCatalogId: 'catalogId',
        inputOtherAmount: 'otherAmount',
        inputCatalogEmail: 'catalogEmail',
        inputEmail: 'email',
        inputForgotEmail: 'forgotEmail',
        fedexResponseFormat: 'YYYY-MM-DDTHH:mm:ss',
        originalEstimatedDeliveryDateFormat: 'YYYY-MM-DDTHH:mm:ss.SSS',
        DATE_FORMAT_DATE_MON_DATE: 'DD-MMM-YYYY',
        quantityExceededMsg: 'Quantity exceeded.',
        cartAccordionDeliveryError: 'This item cannot be shipped to PO Box. Please select a different address.',
        invalidPromoCodeError: 'The promotion can not be applied, order does not qualify',
        accountSold: 'This Credit Account Has Been Sold',
        accountSoldMsg: `This ${params ? params[0] : 'Stoneberry'} Credit® account was sold to ${
          params ? params[1] : ''
        } on ${params ? params[2] : ''}.`,
        accountSoldMsgZD: `This ${params ? params[0] : 'Stoneberry'}® account was sold to ${
          params ? params[1] : ''
        } on ${params ? params[2] : ''}.`,
        accountSolContactMsg: `If the customer has any questions, please direct them to contact ${
          params ? params[0] : ''
        } directly by using the information below.`,
        soldAccountPaymentMsg: `Clicking this button will redirect you to the website for ${
          params ? params[0] : ''
        } to make your
            payment.`,
        checkoutAccountSoldMsg: `This ${params ? params[0] : 'Stoneberry'} Credit® account was sold to ${
          params ? params[1] : ''
        } on`,
        checkoutAccountSoldMsgZD: `This ${params ? params[0] : 'Stoneberry'}® account was sold to ${
          params ? params[1] : ''
        } on`,
        checkoutPaymentMsg: 'Please continue placing with a credit/debit card.',
        securityCodeDescLine1:
          ' The card security code is an anti-fraud security feature to help verify that you are in possession of your credit/debit card.',
        securityCodeDescLine2: ` For Visa, Mastercard or Discover, the three-digit security code is printed on the signature panel on the back of the card, after the card number.`,
        securityCodeDescLine3: ` For American Express, the four-digit security code is printed on the front of the card above the card number.`,
        duplicatePaymentError: `We're sorry, but only one payment can be made per account every 24 hours. Please try again later.`,
        morePricePerMonth: `${params ? params[0] : '0'} more per month*`,
        availableCreditOverage: ` If your order total exceeds your available credit, you may not be approved to use your ${
          params ? params[0] : 'Stoneberry'
        } Credit account for this purchase. Please adjust your order total so it is lower than your available credit, or choose a different payment method at checkout.`,
        orderOverAvailableCredit: `This order is $${
          params ? params[0] : '0.00'
        } over your available credit limit. Please reduce your order total or you may be asked for a down payment or the order may not be approved.`,
        availableCreditOverageText: 'Available Credit Overage',
        discount: 'Discount',
        shippingInsuranceContent: 'csa_shipping_insurance_content',
        withEmailShippingInsuranceContent: 'csa_with_email_shipping_insurance_content',
        withoutEmailShippingInsuranceContent: 'csa_without_email_shipping_insurance_content',
        addWorryFreeDelivery: 'Add Worry-Free Delivery®',
        declineWorryFreeDelivery: 'Decline Worry-Free Delivery®',
      };
  }
};
